import { render, staticRenderFns } from "./Currency.vue?vue&type=template&id=5e8a87f0&scoped=true&lang=pug&"
import script from "./Currency.vue?vue&type=script&lang=ts&"
export * from "./Currency.vue?vue&type=script&lang=ts&"
import style0 from "./Currency.vue?vue&type=style&index=0&id=5e8a87f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8a87f0",
  null
  
)

export default component.exports